import React, {Component} from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';
import * as dataService from "../service/data-info-chart/requestsUtil";
import {
  GRAPH_MARGIN, WHITOUT_INFORMATION, COLORS,
  MONTHLY_RECOVERY_ACUMMULATED
} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";
import * as formatter from "../utils/formatters"

var Loader = require('react-loader');

export default class MonthlyRecoveryAcummulated extends Component {

  constructor(props) {
    super(props);
    this.state = {datas: [], loaded: false, date:this.props.date};
  }

  componentDidMount() {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.state.date
    }

    dataService.postFetch(MONTHLY_RECOVERY_ACUMMULATED, params)
      .then((data) => {
        this.setState({datas: data, loaded: true});
      });
  }

  componentWillReceiveProps(nextProps) {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.props.date
    }

    dataService.postFetch(MONTHLY_RECOVERY_ACUMMULATED, params)
      .then((data) => {
        this.setState({datas: data, loaded: true, date:nextProps.date});
      });
  }

  render() {
    if (this.state.datas.length > 0) {
      return (
        <Loader loaded={this.state.loaded} top="90%">
          <ResponsiveContainer>
            <LineChart width={600} height={300} data={this.state.datas}
                       margin={GRAPH_MARGIN}>
              <XAxis dataKey="month"/>
              <YAxis tickFormatter={formatter.formatNumber} domain={[0, 'dataMax + 3000000']} scale={'linear'}/>
              <CartesianGrid/>
              <Tooltip formatter={formatter.formatNumberMoney}/>
              <Legend verticalAlign={"top"}/>
              <Line type="linear" name={"Actual"} dataKey="amount" stroke={COLORS.GOAL}/>
              <Line type="linear" name={"Anterior"} dataKey="last" stroke={COLORS.AMOUNT} strokeDasharray="5 5"/>
              <Brush dataKey={"mes"} height={20}/>
            </LineChart>
          </ResponsiveContainer>
        </Loader>
      );
    } else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2
        className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }
  }
}





// WEBPACK FOOTER //
// ./src/charts/monthlyRecoveryAccummulated.js